import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/css/all.css'
import axios from 'axios'

function getUrlParams(search) {
  let hashes = search.slice(search.indexOf('?') + 1).split('&')
  return hashes.reduce((params, hash) => {
    let [key, val] = hash.split('=')
    return Object.assign(params, {[key]: decodeURIComponent(val)})
  }, {})
}
let queryParams=getUrlParams(location.search)
if(queryParams.token&&queryParams.token!=""){
  localStorage.setItem('pass', queryParams.token)
  history.replaceState && history.replaceState(
      null, '', location.pathname + location.search.replace(/[\?&]token=[^&]+/, '').replace(/^&/, '?') + location.hash
  )
}

axios.interceptors.request.use(function (config) {
  if (process.env.VUE_APP_LOGIN=='yes') {
    let pass = localStorage.getItem('pass');
    if (pass && pass !== '') {
      config.headers.Authorization = "Bearer " + pass;
    }
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (process.env.VUE_APP_LOGIN=='yes'&&error.response&&401 === error.response.status) {
    if(localStorage.getItem('pass')){
      localStorage.setItem('pass', null)
    }
    if(router.currentRoute.name!=="login") {
      router.push({
        name: 'login',
        params: {
          wantedRoute: router.currentRoute.fullPath
        },
      });
    }
  } else {
    return Promise.reject(error);
  }
})

Vue.config.productionTip = false


import VuetifyDaterangePicker from "vuetify-daterange-picker"
import "vuetify-daterange-picker/dist/vuetify-daterange-picker.css"
Vue.use(VuetifyDaterangePicker)

import { abilitiesPlugin } from '@casl/vue'
import {ability} from './store/ability'
Vue.use(abilitiesPlugin, ability)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



